import { IssueSeverity } from '@gearbelt/global';
import { match } from 'ts-pattern';

import ArrowRightIcon from '@/components/icons/arrow-right';
import { cn } from '@/lib/utils';

interface ListItemProps extends React.HTMLAttributes<HTMLDivElement> {
  issueId: string;
  issueTitle: string;
  issueFieldReference: string;
  issueSeverity: IssueSeverity;
  issueCreatedBy?: string;
}

function ListItem({ className, issueId, issueTitle, issueFieldReference, issueSeverity, issueCreatedBy, ...props }: ListItemProps) {
  const getSeverityColor = (severity: IssueSeverity) => {
    return match(severity)
      .with(IssueSeverity.Low, () => 'bg-default-light-green border-default-green')
      .with(IssueSeverity.Medium, () => 'bg-default-light-yellow border-default-yellow')
      .with(IssueSeverity.High, () => 'bg-default-light-red border-default-red')
      .with(IssueSeverity.Critical, () => 'bg-default-light-red border-default-red')
      .otherwise(() => 'bg-default-light-green border-default-green');
  };

  return (
    <div
      key={issueId}
      className={cn('border-grey-2 active:bg-grey-2 flex h-fit w-full cursor-pointer flex-row items-center gap-2 border-b-2 p-5', className)}
      {...props}>
      <div className="h-[20px] w-[20px]">
        <div className={cn(`h-[20px] w-[20px] rounded-full border-[3px]`, getSeverityColor(issueSeverity))}></div>
      </div>
      <div className="flex h-fit w-full flex-col items-start space-y-1 p-0">
        <div className="text-md text-default-text max-w-[250px] truncate font-medium sm:max-w-[300px] md:max-w-[400px] lg:max-w-[500px]">{issueTitle}</div>
        <div className="text-secondary-text text-sm font-normal">{issueCreatedBy ? issueCreatedBy : issueFieldReference}</div>
      </div>
      <ArrowRightIcon size={30} />
    </div>
  );
}

export { ListItem };
